export const TAG_MAX_LENGTH = 20;
